import React from "react";
import styles from "./NotFoundPage.module.scss";
import notFound from "../../../assets/img/404.svg";

const NotFoundPage = () => {
  React.useEffect(() => {
    document.title = "404 Notfound | 自社でライブコマースできるくん";
  }, []);

  return (
    <div className={styles.main}>
      <img className={styles.imageFrame} alt="404" src={notFound} />
      <div className={styles.copyright}>
        Copyright © 2021 自社でライブコマースできるくん All Rights Reserved.
      </div>
    </div>
  );
};

export default NotFoundPage;
